import {FunctionComponent} from "react";

export const Column: FunctionComponent<any> = (props: any): JSX.Element => null;
